import React from 'react';
import iconBC from '../../../../../../assets/icons/charts/zoomAndFilter/icon_bar_chart.svg';
import SVG from "react-inlinesvg";

const IconBarChart = () => (
    <SVG src={iconBC} height={40} style = {{ marginTop: 10}} />
);
export default IconBarChart;